/**
 * ECS Hero Carousel - Handles automatic rotation using Swiper
 */
document.addEventListener("DOMContentLoaded", function () {
  // Initialize all hero carousels on the page
  const heroCarousels = document.querySelectorAll(".ecs-hero-wrap.swiper");

  heroCarousels.forEach(function (heroNode) {
    initHeroCarousel(heroNode);
  });
});

function initHeroCarousel(heroNode) {
  // Check if there are multiple slides before initializing
  const slidesCount = heroNode.querySelectorAll(".swiper-slide").length;

  if (slidesCount <= 1) {
    // Hide pagination and arrows if only one slide
    const pagination = heroNode.querySelector(".swiper-pagination");
    const prevButton = heroNode.querySelector(".swiper-button-prev");
    const nextButton = heroNode.querySelector(".swiper-button-next");

    if (pagination) pagination.style.display = "none";
    if (prevButton) prevButton.style.display = "none";
    if (nextButton) nextButton.style.display = "none";
    return; // Exit early, don't initialize Swiper
  }

  // Get autoplay speed from data attribute (in seconds), convert to milliseconds
  const autoplaySpeed =
    parseInt(heroNode.getAttribute("data-autoplay-speed")) || 5;
  const AUTOPLAY_DELAY = autoplaySpeed * 1000;

  // Get navigation and pagination elements scoped to this instance
  const paginationEl = heroNode.querySelector(".swiper-pagination");
  const nextButtonEl = heroNode.querySelector(".swiper-button-next");
  const prevButtonEl = heroNode.querySelector(".swiper-button-prev");

  // Initialize Swiper
  const swiper = new Swiper(heroNode, {
    loop: true,
    speed: 600,
    autoplay: {
      delay: AUTOPLAY_DELAY,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
    pagination: {
      el: paginationEl,
      clickable: true,
      bulletClass: "swiper-pagination-bullet ecs-hero-bullet",
      bulletActiveClass: "swiper-pagination-bullet-active",
    },
    navigation: {
      nextEl: nextButtonEl,
      prevEl: prevButtonEl,
    },
    on: {
      init: function () {
        // Swiper is ready
      },
    },
  });

  // Handle touch events for mobile
  heroNode.addEventListener(
    "touchstart",
    function () {
      swiper.autoplay.stop();
    },
    { passive: true }
  );

  heroNode.addEventListener(
    "touchend",
    function () {
      setTimeout(function () {
        swiper.autoplay.start();
      }, 2000);
    },
    { passive: true }
  );
}
